import { render } from "./DocumentShareModal.vue?vue&type=template&id=2ad5b5c5&scoped=true"
import script from "./DocumentShareModal.vue?vue&type=script&lang=js"
export * from "./DocumentShareModal.vue?vue&type=script&lang=js"

import "./DocumentShareModal.vue?vue&type=style&index=0&id=2ad5b5c5&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ad5b5c5"]])

export default __exports__